var map = {
	"./logo1.png": "f229",
	"./logo10.png": "95ce",
	"./logo11.png": "5b60",
	"./logo12.png": "3bb2",
	"./logo13.png": "e146",
	"./logo14.png": "0835",
	"./logo15.png": "c4aa",
	"./logo2.png": "2b82",
	"./logo3.png": "9276",
	"./logo4.png": "7db0",
	"./logo5.png": "07c6",
	"./logo6.png": "31c5",
	"./logo7.png": "79c9",
	"./logo8.png": "7f09",
	"./logo9.png": "3fb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e9b";